// Interface
export interface HomeComponent{
    componentsData: string
}
export interface HomeData{
    groupList : any[]
    isSign : boolean
    homeComponent : HomeComponent
    componentList : any[]
    componentIdsInOrderConfig : any
    isPWA : boolean
    isShowingPWA : boolean
}
export interface BannerItem {
  display: boolean,
  redirectUrl: string
  url: string
}

// Constant
export const HOME_COMPONENT_ID = {
    header: 1,
    banners: 2,
    notice: 3,
    newsBar: 4,
    gameGroups: 5,
    AppDownload: 6,
    shareMedia: 7,
    footerText: 8,
    footer: 9,
    contactService: 10
}

export interface GameList {
    customIcon: string,
    id: number | string,
    gameId: number | string,
    gameMakerId: number | string,
    isFavorite: number,
}
export interface GameGroupData {
    gamesGrid: {
        rowCount: number,
        columnCount: number
    },
    styles: {
        active_font_color: string,
        border_color: string,
    }
}
export interface BannerItem {
  url: string,
  redirectUrl: string,
  display: boolean
}

export interface GroupList {
    name: string,
    customIcon: string,
    id: number | string
}
export interface MediaItem {
    display: boolean,
    redirectUrl: string,
    url: string
}
export interface PartnerList {
    img: string,
    id: number | string
}

export interface PwaOptions {
    url: string
    token?: string | null
    clientId?: string
    tenantId?: string
    isIos?: boolean
    iosPopupRef?: Ref<boolean>
    emitInstall?: () => void
}

export interface FooterImagesItem{
  display: boolean
  url: string
  redirectUrl : string
}

interface GameListResult {
  rows: any[]
  total: number
}
// Function
import { useRouter } from 'vue-router'
import { Ref } from 'vue'
import { Router } from 'vue-router'
import { Share } from '@capacitor/share'
import { playClickSound } from '@/utils/media'
import { getAllGame } from '@/api/common'

export function useNavigation() {
  const router = useRouter()

  const goToPath = (path: string) => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    router.push(path)
  }

  return { goToPath }
}

export function goToLink(path: string) {
  if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
  
  if (!path) return
  window.open(path, '_blank')
}

export function goToActivityPath(
  name: string,
  router: Router,
  emits?: (event: 'openAgentPopup' | 'openRedEnvelop' | 'goToHome' | 'openPWA', ...args: any[]) => void
) {
  if (process.env.VITE_APP_PREVIEW_MODE === 'true' || process.env.VUE_APP_PREVIEW_MODE === 'true') return

  switch (name) {
    case 'user_referral_reward':
      router.push('/sdagency')
      break
    case 'lucky_wheel':
      router.push('/cashwheel')
      break
    case 'recharge_bargain_sales':
      router.push('/sdbigdep')
      break
    case 'agent_cash_back':
      emits?.('openAgentPopup')
      break
    case 'vip_reward':
      router.push('/sd-vip')
      break
    case 'red_envelope_rain':
      emits?.('openRedEnvelop')
      break
    case 'game_benefit':
      router.push('/lossRelief')
      break
    case 'mystery':
      router.push('/sdmystery')
      break
    case 'user_rank':
      router.push('/sd-level')
      break
    case 'first_recharge':
      router.push('/firstRecharge')
      break
    case 'recharge_gift':
      router.push('/rechargeGift')
      break
    case 'return_turnover':
      router.push('/returnTrunover')
      break
    case 'daily_first_recharge':
      router.push('/firstDeposit')
      break
    case 'signin_rewards':
      router.push('/checkinRewards')
      break
    case 'pwa_reward':
      emits?.('openPWA')
      break
    default:
      router.push('/')
      break
  }
}

export const openRegisterPopup = (
  openRegisterLoginPopup: ((type: number) => void) | undefined,
  type: number
) => {
  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return
  openRegisterLoginPopup?.(type)
}

export const goToPlayGame = (
  router: Router,
  openRegisterLoginPopup: ((type: number) => void) | undefined,
  id: string | number,
  makerId: string | number
) => {
  if (process.env.VUE_APP_PREVIEW_MODE === 'true') return
  const token = localStorage.getItem('token')
  if (token) {
    router.push({ path: '/pgame', query: { game_type: id, game_maker: makerId } })
  } else {
    openRegisterLoginPopup?.(1)
  }
}

export const setFirstActiveItem = <T extends { id: string | number }>(
    list: T[],
    activeRef: Ref<string | number>
) => {
    activeRef.value = list[0]?.id || ''
}

export const setActiveItemFromClick = <T extends { id: string | number }>(
    item: T,
    activeRef: Ref<string | number>
) => {
    if (process.env.VUE_APP_PREVIEW_MODE === 'true') return
    activeRef.value = item.id
}

export const emitWithPreviewCheck = (
    emitsFn: (...args: any[]) => void,
    eventName: string,
    payload?: any
) => {
    if (process.env.VUE_APP_PREVIEW_MODE === 'true') return
    emitsFn(eventName, payload)
}

export const goToShare = async (path: string) => {
    if (process.env.VUE_APP_PREVIEW_MODE === 'true') return
    if (!path) return

    try {
        await Share.share({
            text: path,
        })
    } catch (err) {
        console.error('Failed to share:', err)
    }
}

export const openPopup = (popupRef: any) => {
    if (process.env.VUE_APP_PREVIEW_MODE === 'true') return;
    popupRef?.value?.openPopup?.();
}

export const safeNavigate = (router: Router, path: string, stopEvent?: Event) => {
    if (process.env.VUE_APP_PREVIEW_MODE === 'true') return;
    playClickSound();
    stopEvent?.stopPropagation?.();
    router.push(path);
}

export const installPWA = (options: PwaOptions) => {
    
    if (process.env.VUE_APP_PREVIEW_MODE === 'true') return

    const token = localStorage.getItem('token')
    const clientId = process.env.VUE_APP_CLIENT_ID
    const tenantId = process.env.VUE_APP_BASE_TENANT_ID ?? "000000"
    const { url,  isIos, iosPopupRef, emitInstall } = options

     if (!url) {
        if (isIos && iosPopupRef) {
            iosPopupRef.value = true
        } else if (emitInstall) {
            emitInstall()
        }
        return
    }

    if (token) {
        const redirectUrl = `${url}?token=${encodeURIComponent(token)}&clientId=${encodeURIComponent(clientId)}&tenantId=${encodeURIComponent(tenantId) ?? '000000'}`
        window.open(redirectUrl, '_blank')
    } else {
        window.open(url, '_blank')
    }
}

export const checkIosPWAInstallable = () => {
    const isIOS = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone
    return isIOS && isSafari && !isStandalone
}

export const fetchGameList = async (pageNum: number, pageSize: number, searchText: string, keyword?: string): Promise<GameListResult> => {
  const params: any = { pageNum, pageSize, searchText }
  if (keyword) params.keyword = keyword

  try {
    const res = await getAllGame(params)
    return {
      rows: res.data?.rows || [],
      total: res.data?.total || 0,
    }
  } catch (err) {
    console.error('Error fetching game list:', err)
    return { rows: [], total: 0 }
  }
}
export function debounce<T extends (...args: any[]) => void>(fn: T, delay = 500) {
  let timer: ReturnType<typeof setTimeout> | undefined

  return (...args: Parameters<T>) => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}
